// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2oXOT","validationTips":"StatementDescriptor_validationTips__2ZGhF"};